// extracted by mini-css-extract-plugin
module.exports = {"bankDetails":"styles_bankDetails__10FV0","wrapper":"styles_wrapper__2wjYc","empty":"styles_empty__2iuq9"};